export function inputErrorContainer(message) {
    return `<div class="error-message">
                    <div class="error-message__arrow"></div>
                    <div class="error-message__body">${message}</div>
                </div>`
};

export default class FormElement {
    constructor(jqueryObject,validator) {
        this.selector = jqueryObject;
    }


    onValidationResult(result) {
        
        if(result === undefined) {
            this.removeError();
            return true;
        }

        var msg = result.filter(error => {
            return error !== false;
        }).join(',');

        this.setError(msg);

        return false;
    }

    setError(result) {
        this.removeError();
        this.selector.addClass('is-invalid');
        this.selector.parent().append(inputErrorContainer(result));
    }

    removeError() {
        this.selector.parent().find('.error-message').remove();
        this.selector.removeClass('is-invalid');
    }
}